import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { UserRedirectsEnum } from '@services/UserService';
import { MovementsMenuTypesEnum } from '@services/MovimentationService';

import { MovementServiceTypeEnum } from '../enums';
import { type MovementMenuService } from '../types';

export const NEW_CONTRACT_SERVICES: MovementMenuService[] = [
  {
    type: MovementServiceTypeEnum.NEW_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="medical-b2b-add-group"
        size={32}
      />
    ),
    title: 'Inclusão de novos beneficiários',
    description: 'Solicite a inclusão de novos titulares e seus dependentes.',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_INCLUDE_BENEFICIARY,
        enum: MovementsMenuTypesEnum.MovementScreenIncludeBeneficiary,
        title: 'Inclusão de titular e dependentes',
        description:
          'Solicite a inclusão de novos titulares e seus dependentes.',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CANCEL_INCLUDE_BENEFICIARY,
        enum: MovementsMenuTypesEnum.MovementScreenCancelIncludeBeneficiary,
        title: 'Cancelar pedido de inclusão de titular e dependentes',
        description: 'Cancele pedidos de inclusão antes da ativação da vida.',
      },
    ],
  },
  {
    type: MovementServiceTypeEnum.NEW_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="medical-b2b-contract-edit"
        size={32}
      />
    ),
    title: 'Alteração de pedidos',
    description:
      'Solicite a alteração de dados de novos titulares e dependentes.',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CHANGE_INCLUDE_BENEFICIARY,
        enum: MovementsMenuTypesEnum.MovementScreenChangeIncludeBeneficiary,
        title: 'Alterar pedido de inclusão de titular e dependentes',
        description:
          'Solicite a alteração de informações de novos titulares e seus dependentes.',
      },
    ],
  },
  {
    type: MovementServiceTypeEnum.NEW_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="actions-b2b-swap-vertical"
        size={32}
      />
    ),
    title: 'Alteração de Unidade',
    description:
      'Solicite a alteração da unidade de novos titulares e dependentes.',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CHANGE_UNIT_INCLUDE_BENEFICIARY,
        enum: MovementsMenuTypesEnum.MovementScreenChangeUnitIncludeBeneficiary,
        title: 'Alterar Unidade',
        description:
          'Solicite a alteração da unidade de novos titulares e dependentes.',
      },
    ],
  },
];
